<template>
  <div class="wrapper wrapper-content p-0 animated fadeInUp">
    <div class="ibox-body">
       <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>Schedule List</h5>
        <div class="position-relative align-self-center">
        <img src="@/assets/img/create.png" width="17" alt="Add Schedule"
          style="cursor: pointer;" @click="addNewRow" />
        <div class="tool-tip mt-2">Add Schedule</div>
      </div>
       </div>
      <div class="ibox-content">
       
        <div>
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>
                    Visit No <sup><i class="fa fa-asterisk required"></i></sup>
                  </th>
                  <th>Pre Visit (Days)</th>
                  <th>Post-visit (Days)</th>
                  <th>Visit Period (Days)</th>
                  <th>Visit Period (Weeks)</th>
                  <th>Visit Period (Months)</th>
                  <th>Visit Period (Year)</th>
                  <th>SoA Id</th>
                  <th class="text-center">Edit</th>
                  <th class="text-center">Delete</th>
                </tr>
              </thead>
              <tbody>
                   <!-- New Row for creation -->
              <tr v-if="isAddingNew">
                <td>
                  <input v-model="newRow.visitNo" class="form-control" type="text"
                    @input="clearNewFieldError('visitNo')" />
                  <div v-if="newRowErrors.visitNo" class="text-danger">{{ newRowErrors.visitNo }}</div>
                </td>
                <td>
                  <input v-model="newRow.preVisit" class="form-control" type="number"
                    :min="0" @change="checkNewNegative" />
                </td>
                <td>
                  <input v-model="newRow.postVisit" class="form-control" type="number"
                    :min="0" @change="checkNewNegative" />
                </td>
                <td>
                  <input v-model="newRow.visitPeriodDay" class="form-control" type="number"
                    :min="0" @change="checkNewNegative" />
                </td>
                <td>
                  <input v-model="newRow.visitPeriodWeek" class="form-control" type="number"
                    :min="0" @change="checkNewNegative" />
                </td>
                <td>
                  <input v-model="newRow.visitPeriodMonth" class="form-control" type="number"
                    :min="0" @change="checkNewNegative" />
                </td>
                <td>
                  <input v-model="newRow.visitPeriodYear" class="form-control" type="number"
                    :min="0" @change="checkNewNegative" />
                </td>
                <td>
                  <input v-model="newRow.soaId" class="form-control" type="text" />
                </td>
                <td class="text-center">
                  <i class="fa fa-check action-icon text-success" @click="saveNewRow" title="Save"></i>
                  <i class="fa fa-times action-icon text-danger" @click="cancelNewRow" title="Cancel"></i>
                </td>
                <td></td>
              </tr>

              <!-- No data row -->
              <tr v-if="!isAddingNew && schedules.length === 0">
                <td colspan="10" class="text-center">No data available.</td>
              </tr>
                <tr
                  v-for="(schedule, index) in schedules"
                  :key="schedule.visitNo"
                >
                  <td v-if="editIndex !== index">{{ schedule.visitNo }}</td>
                  <td v-else>
                    <input
                      v-model="editableRow.visitNo"
                      class="form-control"
                      type="text"
                      @input="clearFieldError('visitNo')"
                    />
                    <div v-if="validationErrors.visitNo" class="text-danger">
                      {{ validationErrors.visitNo }}
                    </div>
                  </td>
                  <td v-if="editIndex !== index">{{ schedule.preVisit }}</td>
                  <td v-else>
                    <input
                      v-model="editableRow.preVisit"
                      class="form-control"
                      type="number"
                      :min="0"
                      @change="checknegative"
                    />
                  </td>
                  <td v-if="editIndex !== index">{{ schedule.postVisit }}</td>
                  <td v-else>
                    <input
                      v-model="editableRow.postVisit"
                      class="form-control"
                      type="number"
                      :min="0"
                      @change="checknegative"
                    />
                  </td>
                  <td v-if="editIndex !== index">
                    {{ schedule.visitPeriodDay }}
                  </td>
                  <td v-else>
                    <input
                      v-model="editableRow.visitPeriodDay"
                      class="form-control"
                      type="number"
                      :min="0"
                      @change="checknegative"
                    />
                  </td>
                  <td v-if="editIndex !== index">
                    {{ schedule.visitPeriodWeek }}
                  </td>
                  <td v-else>
                    <input
                      v-model="editableRow.visitPeriodWeek"
                      class="form-control"
                      type="number"
                      :min="0"
                      @change="checknegative"
                    />
                  </td>
                  <td v-if="editIndex !== index">
                    {{ schedule.visitPeriodMonth }}
                  </td>
                  <td v-else>
                    <input
                      v-model="editableRow.visitPeriodMonth"
                      class="form-control"
                      type="number"
                      :min="0"
                      @change="checknegative"
                    />
                  </td>
                  <td v-if="editIndex !== index">
                    {{ schedule.visitPeriodYear }}
                  </td>
                  <td v-else>
                    <input
                      v-model="editableRow.visitPeriodYear"
                      class="form-control"
                      type="number"
                      :min="0"
                      @change="checknegative"
                    />
                  </td>
                  <td v-if="editIndex !== index">
                    {{ schedule.soaId }}
                  </td>
                  <td v-else>
                    <input
                      v-model="editableRow.soaId"
                      class="form-control"
                      type="text"
                    />
                  </td>
                  <td class="text-center">
                    <template v-if="editIndex !== index">
                      <i
                        class="fa fa-edit edit-delete"
                       v-if="protocol.status !== 'Generated'"
                        @click.prevent="editRow(index, schedule)"
                      ></i>
                    </template>
                    <template v-else>
                      <i
                        class="fa fa-check action-icon text-success"
                        @click="updateRow(schedule.id, schedule.studyId)"
                        title="Update"
                      ></i>
                      <i
                        class="fa fa-times action-icon text-danger"
                        @click="cancelEdit"
                        title="Cancel"
                      ></i>
                    </template>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-trash edit-delete"
                      v-if="protocol.status !== 'Generated'"
                      style="color: #a13b7c"
                      @click="deleteRow(schedule.id)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Pagination  -->
          <div class="row mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div
                class="
                    dataTables_paginate
                    paging_simple_numbers
                    pagination
                    float-right
                  "
              >
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination
                    v-model="currentPage"
                    :pages="totalPages"
                    :range-size="0"
                    active-color="#618bd7"
                    @update:modelValue="loadPage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.action-icon {
  cursor: pointer;
  font-size: 18px;
  margin: 0 5px;
}

.action-icon:hover {
  opacity: 0.8;
}

.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}
.position-relative .tool-tip {  
  right: 20px;
  top: 0px;
}
</style>
<script src="./ScheduleManagement.js"></script>
